import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../Graphic.js";
import i from "../core/Collection.js";
import r from "../core/CollectionFlattener.js";
import s from "../core/Error.js";
import a from "../core/has.js";
import { isIterable as n } from "../core/iteratorUtils.js";
import o from "../core/Logger.js";
import { isSome as h } from "../core/maybe.js";
import { init as l } from "../core/watchUtils.js";
import { initialize as p } from "../core/workers/workers.js";
import { property as d } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as c } from "../core/accessorSupport/decorators/subclass.js";
import { BreakpointsOwner as u } from "./BreakpointsOwner.js";
import { DOMContainer as g } from "./DOMContainer.js";
import m from "./MapViewBase.js";
import w from "./2d/input/MapViewInputManager.js";
import y from "./2d/support/HighlightOptions.js";
import f from "./support/createScreenshotPlan.js";
import { getMaximumResolutionScale as v, getFormatAndQuality as V } from "./support/screenshotUtils.js";
import { isSupportedScreenPointEvent as b, createScreenPointFromSupportedEvent as _ } from "./support/screenUtils.js";
import { check as M } from "./support/WebGLRequirements.js";
import j from "./ui/2d/DefaultUI2D.js";
import L from "../webmap/background/ColorBackground.js";
var O = o.getLogger("esri.views.MapView");
var S, C, k, E, x, N;

function W() {
  return _W.apply(this, arguments);
}

function _W() {
  _W = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, e, t, i, r, s, a;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([import("./webgl.js"), import("./2d/mapViewDeps.js")]);

          case 2:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            _yield$Promise$all2$ = _yield$Promise$all2[1];
            e = _yield$Promise$all2$.GraphicsView2D;
            t = _yield$Promise$all2$.GraphicContainer;
            i = _yield$Promise$all2$.LabelManager;
            r = _yield$Promise$all2$.MapViewNavigation;
            s = _yield$Promise$all2$.MagnifierView2D;
            a = _yield$Promise$all2$.Stage;
            C = e, k = t, E = i, x = r, N = s, S = a;

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _W.apply(this, arguments);
}

var P = /*#__PURE__*/function (_u) {
  _inherits(P, _u);

  var _super = _createSuper(P);

  function P(e) {
    var _this;

    _classCallCheck(this, P);

    _this = _super.call(this, e), _this._magnifierView = null, _this._stage = null, _this._resolveWhenReady = [], _this.rootLayerViews = new r({
      getCollections: function getCollections() {
        var e, t;
        return [null == (e = _this.basemapView) ? void 0 : e.baseLayerViews, _this.layerViews, null == (t = _this.basemapView) ? void 0 : t.referenceLayerViews];
      },
      getChildrenFunction: function getChildrenFunction() {
        return null;
      }
    }), _this.floors = new i(), _this.graphicsView = null, _this.highlightOptions = new y(), _this.inputManager = new w({
      view: _assertThisInitialized(_this)
    }), _this.mapViewNavigation = null, _this.supersampleScreenshotsEnabled = !1, _this.ui = new j(), _this.rendering = !1, p();
    return _this;
  }

  _createClass(P, [{
    key: "destroy",
    value: function destroy() {
      this.rootLayerViews.destroy(), this.inputManager.destroy(), this._set("inputManager", null);
    }
  }, {
    key: "background",
    get: function get() {
      return this.get("map.initialViewProperties.background") || null;
    },
    set: function set(e) {
      void 0 === e ? this._clearOverride("background") : this._override("background", e);
    }
  }, {
    key: "resourceManager",
    get: function get() {
      return this._stage.resourceManager;
    }
  }, {
    key: "textureManager",
    get: function get() {
      return this._stage.painter.textureManager;
    }
  }, {
    key: "navigating",
    get: function get() {
      return !(!this.mapViewNavigation || !this.mapViewNavigation.interacting);
    }
  }, {
    key: "toMap",
    value: function toMap(e) {
      if (b(e)) {
        var _t = _(this, e);

        return _get(_getPrototypeOf(P.prototype), "toMap", this).call(this, _t);
      }

      return _get(_getPrototypeOf(P.prototype), "toMap", this).call(this, e);
    }
  }, {
    key: "hitTest",
    value: function () {
      var _hitTest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        var i, r, s, a, n, o, l, p;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = b(e) ? _(this, e) : e;

                if (!(!this.ready || isNaN(i.x) || isNaN(i.y))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", {
                  screenPoint: i,
                  results: []
                });

              case 3:
                r = new Set(), s = !1, a = null, n = null;
                null != t && t.include ? q(t.include, U(this, function (e) {
                  return r.add(e);
                }, function (e) {
                  a || (a = new Set()), a.add(e);
                }, function (e) {
                  return r.add(e);
                }, function () {
                  return s = !0;
                })) : (s = !0, r = new Set(this.allLayerViews)), null != t && t.exclude && q(t.exclude, U(this, function (e) {
                  return r.delete(e);
                }, function (e) {
                  n || (n = new Set()), n.add(e);
                }));
                o = this.allLayerViews.filter(function (e) {
                  return !e.suspended && r.has(e);
                }).reverse(), l = this.toMap(i);
                _context.next = 8;
                return Promise.all([s ? this.graphicsView.hitTest(l) : null].concat(_toConsumableArray(o.map(function (e) {
                  return e.hitTest(l, i);
                }))));

              case 8:
                p = _context.sent.filter(h).flat();
                return _context.abrupt("return", (a && (p = p.filter(function (e) {
                  return a.has(G(e));
                })), n && (p = p.filter(function (e) {
                  return !n.has(G(e));
                })), {
                  screenPoint: i,
                  results: p.map(function (e) {
                    return {
                      mapPoint: l,
                      graphic: e
                    };
                  })
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hitTest(_x, _x2) {
        return _hitTest.apply(this, arguments);
      }

      return hitTest;
    }()
  }, {
    key: "takeScreenshot",
    value: function takeScreenshot(e) {
      var _this2 = this;

      e = e || {};
      var t = this.supersampleScreenshotsEnabled ? Math.min(4, v(this.size, Math.min(4096, this._stage.context.parameters.maxTextureSize))) : 1;
      var i;
      e.layers ? (i = [], e.layers.forEach(function (e) {
        var t = _this2.allLayerViews.find(function (t) {
          return t.layer.id === e.id;
        });

        t && "container" in t && t.container && i.push(t.container);
      })) : i = this._stage.children;

      var _V = V(e.format, e.quality),
          r = _V.format,
          s = _V.quality,
          a = f(e, t, this.size, this.padding, r, s, i, e.rotation);

      return this._stage.takeScreenshot(a);
    }
  }, {
    key: "on",
    value: function on(e, t, i, r) {
      var s = this.inputManager && this.viewEvents.on(e, t, i, r);
      return s || _get(_getPrototypeOf(P.prototype), "on", this).call(this, e, t);
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(e) {
      return _get(_getPrototypeOf(P.prototype), "hasEventListener", this).call(this, e) || this.viewEvents.hasHandler(e);
    }
  }, {
    key: "whenLayerView",
    value: function whenLayerView(e) {
      return _get(_getPrototypeOf(P.prototype), "whenLayerView", this).call(this, e);
    }
  }, {
    key: "graphicChanged",
    value: function graphicChanged(e) {
      if (this.graphicsView) {
        this.graphicsView.graphicUpdateHandler(e);
      }
    }
  }, {
    key: "whenReady",
    value: function whenReady() {
      var _this3 = this;

      return new Promise(function (e) {
        _this3.ready ? e(_this3) : _this3._resolveWhenReady.push(e);
      });
    }
  }, {
    key: "forceDOMReadyCycle",
    value: function forceDOMReadyCycle() {
      this.forceReadyCycle();
    }
  }, {
    key: "validate",
    value: function validate() {
      var e = M({
        checkMajorWebPerformanceCaveat: !1
      });
      return a("safari") && a("safari") < 9 && (e = new s("mapview:browser-not-supported", "This browser is not supported by MapView (Safari < 9)", {
        type: "safari",
        requiredVersion: 9,
        detectedVersion: a("safari")
      })), h(e) ? (O.warn("#validate()", e.message), Promise.reject(e)) : W();
    }
  }, {
    key: "_startup",
    value: function _startup() {
      var _this4 = this;

      this.timeline.begin("MapView Startup"), _get(_getPrototypeOf(P.prototype), "_startup", this).call(this), this.graphics.owner = this;
      var e = {
        disabledExtensions: this.deactivatedWebGLExtensions,
        debugWebGLExtensions: this.debugWebGLExtensions
      },
          t = new S(this.surface, {
        canvas: this.renderCanvas,
        supersampleScreenshots: this.supersampleScreenshotsEnabled,
        contextOptions: e,
        renderingOptions: this.renderingOptions,
        timeline: this.timeline
      }),
          i = new C({
        view: this,
        graphics: this.graphics,
        requestUpdateCallback: function requestUpdateCallback() {
          return _this4.requestUpdate();
        },
        container: new k(this.featuresTilingScheme)
      }),
          r = new x({
        view: this,
        animationManager: this.animationManager
      }),
          s = new E({
        view: this
      });
      this._magnifierView = new N(), this._magnifierView.magnifier = this.magnifier, this._stage = t, this.frameTask.graphicsView = i, this._set("graphicsView", i), this._set("mapViewNavigation", r), this._set("labelManager", s), this.handles.add([this.rootLayerViews.on("change", function () {
        return _this4._updateStageChildren();
      }), t.on("post-render", function () {
        return _this4._set("rendering", t.renderRequested);
      }), t.on("will-render", function () {
        return _this4._set("rendering", t.renderRequested);
      }), t.on("webgl-error", function (e) {
        return _this4.fatalError = e.error;
      }), l(this, "stationary", function (e) {
        return t.stationary = e;
      }, !0), l(this, "state.id", function () {
        return t.state = _this4.state;
      }, !0), l(this, "background", function (e) {
        t.background = e, _this4._magnifierView.background = e;
      }, !0), l(this, "magnifier", function (e) {
        return _this4._magnifierView.magnifier = e;
      }, !0), l(this, "renderingOptions", function (e) {
        return t.renderingOptions = e;
      }, !0), l(this, "highlightOptions", function () {
        return t.highlightOptions = _this4.highlightOptions;
      }, !0)], "map-view"), t.state = this.state, this._updateStageChildren();
      var a = this._resolveWhenReady;
      this._resolveWhenReady = [], a.forEach(function (e) {
        return e(_this4);
      }), this.timeline.end("MapView Startup");
    }
  }, {
    key: "_teardown",
    value: function _teardown() {
      this.handles.remove("map-view"), this.layerViewManager.clear(), this.labelManager.destroy(), this._magnifierView.destroy(), this._stage.destroy();
      this.graphicsView.destroy(), this.mapViewNavigation.destroy(), this._stage = null, this._set("graphicsView", null), this._magnifierView = null, this._set("labelManager", null), this._set("mapViewNavigation", null), this.graphics.owner = null, _get(_getPrototypeOf(P.prototype), "_teardown", this).call(this);
    }
  }, {
    key: "_updateStageChildren",
    value: function _updateStageChildren() {
      var _this5 = this;

      this._stage.removeAllChildren(), this.rootLayerViews.forEach(function (e) {
        _this5._stage.addChild(e.container);
      });
      var e = this.graphicsView;
      this._stage.addChild(e.container), this._stage.addChild(this._magnifierView);
    }
  }]);

  return P;
}(u(g(m)));

e([d({
  type: L
})], P.prototype, "background", null), e([d()], P.prototype, "floors", void 0), e([d()], P.prototype, "graphicsView", void 0), e([d({
  type: y
})], P.prototype, "highlightOptions", void 0), e([d({
  readOnly: !0
})], P.prototype, "inputManager", void 0), e([d({
  readOnly: !0
})], P.prototype, "resourceManager", null), e([d({
  readOnly: !0
})], P.prototype, "textureManager", null), e([d({
  readOnly: !0
})], P.prototype, "mapViewNavigation", void 0), e([d({
  type: Boolean
})], P.prototype, "navigating", null), e([d({
  type: Boolean,
  constructOnly: !0
})], P.prototype, "supersampleScreenshotsEnabled", void 0), e([d({
  type: j
})], P.prototype, "ui", void 0), e([d({
  readOnly: !0
})], P.prototype, "rendering", void 0), e([d({
  constructOnly: !0
})], P.prototype, "renderCanvas", void 0), e([d({
  constructOnly: !0
})], P.prototype, "deactivatedWebGLExtensions", void 0), e([d({
  constructOnly: !0
})], P.prototype, "debugWebGLExtensions", void 0), P = e([c("esri.views.MapView")], P);
var R = P;

function G(e) {
  var t = e.getObjectId();
  var i, r, s, a;
  return t ? "".concat(null != (i = null != (r = null == (s = e.layer) ? void 0 : s.uid) ? r : null == (a = e.sourceLayer) ? void 0 : a.uid) ? i : "MapView", "/").concat(t) : "\"MapView/".concat(e.uid);
}

function U(e, i, r, s, a) {
  return function (n) {
    if (n instanceof t) {
      if (n.layer === e) null == a || a();else {
        var _t2 = e.allLayerViews.find(function (e) {
          return e.layer === n.layer;
        });

        _t2 && (null == s || s(_t2));
      }
      r(G(n));
    } else {
      var _t3 = e.allLayerViews.find(function (e) {
        return e.layer === n;
      });

      _t3 && i(_t3);
    }
  };
}

function q(e, t) {
  if (e) if (n(e)) {
    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _i = _step.value;

        if (n(_i)) {
          var _iterator2 = _createForOfIteratorHelper(_i),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _e = _step2.value;
              t(_e);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else t(_i);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else t(e);
}

export { R as default };